const IMPORT_STATUS_NEED_DEDUPLICATE = 1

const getLength = (list?: any[]) => list?.length || 0

export const hasRepeatImportReviewEntry = (info?: any) =>
    !!info &&
    (info.import_status === IMPORT_STATUS_NEED_DEDUPLICATE ||
        getLength(info.duplicated_member_pairs) > 0 ||
        getLength(info.duplicated_card_code_member_pairs) > 0 ||
        getLength(info.duplicated_old_ls_pairs) > 0)

export const getRepeatImportActionText = (info?: any) =>
    info?.import_status === IMPORT_STATUS_NEED_DEDUPLICATE || getLength(info?.duplicated_member_pairs) > 0
        ? '处理重复会员'
        : '查看导入异常'

export const getInitialRepeatTab = (duplicatedPairs?: any[], cardCodePairs?: any[], oldLsPairs?: any[]) => {
    if (getLength(duplicatedPairs) > 0) return 0
    if (getLength(cardCodePairs) > 0) return 1
    if (getLength(oldLsPairs) > 0) return 2

    return 0
}

export const getRepeatChoiceText = (source: number) => (source === 1 ? '使用导入基础数据' : '保留已有会员')
